import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api/api';

const FormularioCredor = ({ onSucesso }) => {

    const navigate = useNavigate();

    const [dados, setDados] = useState({
        nomeExibicao: '',
        documento: '',
        emailContato: '',
        chavePixClinica: '',       // 🔥 NOVO
        percentualHonorarios: ''   // 🔥 NOVO
    });

    const [logo, setLogo] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setDados(prev => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        setLogo(e.target.files[0]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        // Garante que o percentual seja um número antes de enviar para o backend
        const payload = {
            ...dados,
            percentualHonorarios: dados.percentualHonorarios ? parseFloat(dados.percentualHonorarios) : 0
        };

        const formData = new FormData();
        const jsonDados = JSON.stringify(payload);
        const blobDados = new Blob([jsonDados], { type: 'application/json' });
        
        formData.append('dados', blobDados);
        
        if (logo) {
            formData.append('fotoPerfil', logo);
        }

        try {
            await api.post('/assinante/credores', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            
            alert("Credor cadastrado com sucesso!");
            
            if (onSucesso) onSucesso(); 
            
            navigate('/dashboard'); 

        } catch (error) {
            console.error("Erro ao cadastrar credor:", error.response?.data);
            alert("Erro ao cadastrar. Verifique os dados ou o limite do seu plano.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.contentWrapper}>
                
                <button onClick={() => navigate('/dashboard')} style={styles.btnVoltar}>
                    ← Voltar ao Dashboard
                </button>

                <form onSubmit={handleSubmit} style={styles.form}>
                    <h3 style={{color: 'white', marginBottom: '20px', marginTop: 0}}>Novo Credor (Clínica/Cliente)</h3>
                    
                    <input name="nomeExibicao" placeholder="Nome de Exibição" onChange={handleChange} style={styles.input} required />
                    <input name="documento" placeholder="CNPJ ou CPF" onChange={handleChange} style={styles.input} required />
                    <input name="emailContato" type="email" placeholder="E-mail de Contato" onChange={handleChange} style={styles.input} required />

                    {/* --- INÍCIO DAS REGRAS FINANCEIRAS --- */}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                        <label style={styles.label}>Chave PIX da Clínica (Recebimento):</label>
                        <input 
                            name="chavePixClinica" 
                            placeholder="Ex: 12.345.678/0001-99" 
                            onChange={handleChange} 
                            style={styles.input} 
                            required 
                        />
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                        <label style={styles.label}>Sua Comissão / Honorários (%):</label>
                        <input 
                            name="percentualHonorarios" 
                            type="number" 
                            step="0.01" 
                            min="0" 
                            max="100" 
                            placeholder="Ex: 15.00" 
                            onChange={handleChange} 
                            style={styles.input} 
                            required 
                        />
                    </div>
                    {/* --- FIM DAS REGRAS FINANCEIRAS --- */}

                    <label style={styles.fileLabel}>
                        Logo do Credor (Opcional):
                        <input type="file" onChange={handleFileChange} style={{marginTop: '10px'}} accept="image/*" />
                    </label>

                    <button type="submit" disabled={loading} style={styles.button}>
                        {loading ? 'Salvando...' : 'Cadastrar Credor'}
                    </button>
                </form>
            </div>
        </div>
    );
};

const styles = {
    container: { display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: '#020617', padding: '20px' },
    contentWrapper: { width: '100%', maxWidth: '400px' },
    
    btnVoltar: { background: 'transparent', color: '#94a3b8', border: 'none', cursor: 'pointer', fontSize: '0.95rem', marginBottom: '15px', padding: 0, display: 'inline-block', textAlign: 'left' },
    
    form: { display: 'flex', flexDirection: 'column', gap: '15px', background: 'rgba(255,255,255,0.05)', padding: '30px', borderRadius: '12px', width: '100%', boxSizing: 'border-box' },
    input: { background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)', padding: '12px', borderRadius: '8px', color: 'white', fontSize: '1rem', width: '100%', boxSizing: 'border-box' },
    
    label: { color: '#94a3b8', fontSize: '0.85rem' }, // Estilo novo para as labels dos campos financeiros
    fileLabel: { color: '#94a3b8', fontSize: '0.9rem', display: 'flex', flexDirection: 'column' },
    
    button: { background: '#10b981', color: '#022c22', padding: '15px', borderRadius: '8px', border: 'none', fontWeight: 'bold', cursor: 'pointer', marginTop: '10px', fontSize: '1rem' }
};

export default FormularioCredor;